import { ChevronLeft } from '@hhgtech/icons/arrow'
import { Box } from '@mantine/core'
import cls from 'classnames'

const ControlPrev = ({
  canScrollPrev,
  onClick,
}: {
  canScrollPrev: boolean
  onClick: () => void
}) => {
  return (
    <Box
      className={cls(
        'flex w-12 h-10 absolute left-0 top-0 z-[1] transition-all',
        {
          'opacity-0 pointer-events-none': !canScrollPrev,
        },
      )}
    >
      <Box className="w-6 bg-white py-2 cursor-pointer" onClick={onClick}>
        <ChevronLeft size={24} />
      </Box>
      <Box
        className="w-6"
        style={{
          background:
            'linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
        }}
      />
    </Box>
  )
}

export default ControlPrev
